import React, { Component } from "react";
import { motion } from "framer-motion";
import "../styles/detalle70.css";

class AdecuacionesPAAS2025 extends Component {
  documentos = [
    {
      titulo: "Adecuación PAAS 2025 - 1er. Trimestre",
      archivo: "/PDF/AdecuacionesPAAS2025/1erTrimestre.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Adecuación PAAS 2025 - 2do. Trimestre",
      archivo: "/PDF/AdecuacionesPAAS2025/2doTrimestre.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Adecuación PAAS 2025 - 3er. Trimestre",
      archivo: "/PDF/AdecuacionesPAAS2025/3erTrimestre.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Adecuación PAAS 2025 - 4to. Trimestre",
      archivo: "/PDF/AdecuacionesPAAS2025/4toTrimestre.pdf",
      miniatura: "/images/pdf-thumb.png"
    }
  ];

  renderCard = (doc, index) => {
    return (
      <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
        <motion.div
          className="pdf-card"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ scale: 1.05 }}
        >
          <div className="pdf-thumb">
            <img src={doc.miniatura} alt={doc.titulo} />
          </div>

          <h3 className="pdf-title">{doc.titulo}</h3>

          <a
            href={doc.archivo}
            target="_blank"
            rel="noopener noreferrer"
            className="pdf-btn"
          >
            Ver PDF
          </a>
        </motion.div>
      </div>
    );
  };

  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Adecuaciones PAAS 2025</h2>
          </header>

          <div className="row">
            {this.documentos.map(this.renderCard)}
          </div>
        </div>
      </div>
    );
  }
}

export default AdecuacionesPAAS2025;